'use client';

import React, { createContext, useContext } from 'react';

export interface StockBarMeta {
  companyName: string;
  ticker: string;
  fullTicker: string;
  type?: string;
  etfEmoji?: string | null;
  country?: string;
  sector?: string;
  industry?: string;
  industrygroup?: string;
  marketCap?: number | null;
  priceLtm?: number | null;
  /** How many Bastion portfolios currently hold this ticker (0 = none). */
  portfoliosCount?: number;
}

const StockBarMetaContext = createContext<StockBarMeta | null>(null);

export function StockBarMetaProvider({
  meta,
  children,
}: {
  meta: StockBarMeta;
  children: React.ReactNode;
}) {
  return (
    <StockBarMetaContext.Provider value={meta}>
      {children}
    </StockBarMetaContext.Provider>
  );
}

export function useStockBarMeta() {
  return useContext(StockBarMetaContext);
}
